import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
// import settings from '../../common/settings';
// import Tour from '../Tour';
import UserAvatar from '../UserAvatar';
import Breadcrumb from '../../common/components/base/Breadcrumb';
import PageHeader from './PageHeader';

// const {
//   features: { disableTour },
// } = settings.public;

const PageBar = ({
  // eslint-disable-next-line react/prop-types
  history,
  title,
  subTitle,
  description,
  backUrl,
  extra,
  routes,
  isNewPresentation,
}) => {
  const props = {
    onBack: null,
  };

  if (backUrl) {
    // eslint-disable-next-line react/prop-types
    props.onBack = () => history.push(backUrl);
  }

  const pageBarExtra = (
    <div className="cluster-6 items-center">
      {/* {extra || (disableTour ? null : <Tour />)} */}
      {extra}
      <UserAvatar />
    </div>
  );

  return (
    <PageHeader
      title={title}
      subTitle={subTitle}
      description={description}
      extra={pageBarExtra}
      isNewPresentation={isNewPresentation}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {!isEmpty(routes) && <Breadcrumb size="small" routes={routes} />}
    </PageHeader>
  );
};

PageBar.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.node,
  description: PropTypes.string,
  backUrl: PropTypes.string,
  extra: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  routes: PropTypes.array,
  isNewPresentation: PropTypes.bool,
};

PageBar.defaultProps = {
  title: null,
  subTitle: null,
  description: null,
  backUrl: null,
  extra: null,
  routes: [],
  isNewPresentation: false,
};

export default withRouter(PageBar);
